import { observer } from 'mobx-react-lite';
import type { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

import InfoIcon from 'src/shared/assets/icons/info-i.svg';
import { Button } from 'src/shared/components/button';
import { Tooltip } from 'src/shared/components/tooltip';

import styles from './resotre-rig-operation-to-directory-values-button.module.scss';

type Props = {
  isLoading?: boolean;
  onRestoreToDirectoryValues(e: MouseEvent): void;
};

export const RestoreRigOperationToDirectoryValuesButton = observer(function RestoreRigOperationToDirectoryValuesButton({
  isLoading,
  onRestoreToDirectoryValues,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <Button variant="primary" isLoading={isLoading} disabled={isLoading} onClick={onRestoreToDirectoryValues}>
        {t('newWellForm:Approaches.restoreToDirectoryValues')}
      </Button>
      <Tooltip text={t('rigOperations:restoreToDirectoryValuesTooltipText')}>
        <button className={styles.infoIconButton}>
          <InfoIcon width={20} height={20} className={styles.infoIcon} />
        </button>
      </Tooltip>
    </div>
  );
});
